module.exports = __webpack_public_path__ + "images/browse-to-upload.png?859481987e31cdb575ed8e8761ee786a";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/browse-to-upload.png
// module id = d1Bj
// module chunks = 23